<script>
  import RowsContainer from "../container/RowsContainer.svelte";
  import StepperHeadline from "../stepper/StepperHeadline.svelte";

  import FileSelect from "../ui/FileSelect.svelte";
  import { rgbToHex } from "../../helper/UIHelper";

  import ColorThief from "colorthief/dist/color-thief.min.js";

  export let model;
  let logoUid;

  const onLogoChange = () => {
    if (model.logo == null) {
      model.logoPalette = null;
      model.mainColor.hex = null;
      return;
    }
    console.log(model.logo);
    setTimeout(async () => {
      const colorThief = new ColorThief();
      const img = document.getElementById(`preview_${logoUid}`);
      if (img == null) return;
      model.logoPalette = await colorThief.getPalette(img, 5);
      model.mainColor.hex = rgbToHex(
        model.logoPalette[0][0],
        model.logoPalette[0][1],
        model.logoPalette[0][2]
      );
    }, 200);
  };
  const placeholderImage = {
    url: "./assets/Logo.png",
    class: "h-16"
  };
</script>

<div>
  <StepperHeadline>
    <h1>
      Upload your
      <span class="text-yellow">logo</span>
    </h1>
    <p>
      We’ll integrate it automatically in your generated designs.
      <br />
      Or continue without uploading to use our default logo.
    </p>
  </StepperHeadline>
  <RowsContainer>
    <div class="text-center" />
    <div class="text-center">
      <FileSelect
        bind:model={model.logo}
        on:change={onLogoChange}
        bind:uid={logoUid}
        {placeholderImage}
        previewMode={1} />
    </div>
    <div class="text-center" />
  </RowsContainer>
</div>
